import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { paths } from '@/config/paths';
import { AGENT_ID_TO_LOGIN_SLUG } from '@/config/subdomain-config';

interface PrivateRouteProps {
  isAuthenticated: boolean;
  children: React.ReactElement;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({
  isAuthenticated,
  children,
}) => {
  const location = useLocation();

  if (!isAuthenticated) {
    localStorage.setItem('loginRedirectPath', location.pathname + location.search);

    const agentMatch = location.pathname.match(/^\/assistant\/([^/]+)/);
    if (agentMatch) {
      const slug = AGENT_ID_TO_LOGIN_SLUG[agentMatch[1]] ?? agentMatch[1];
      return <Navigate to={`${paths.Login}/${slug}`} replace />;
    }

    return <Navigate to={paths.Login} replace />;
  }
  return children;
};
